import { Exception } from '@core/exceptions/exception';

export class PasswordRecoverException extends Exception {
  constructor(message = 'Password recover exception.') {
    super(message);
  }
}
